import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { request } from './base'

export async function getRestaurantList() {
  const resp = await request(`/cms/getRestaurantsByCMS`, 'get')
  return resp?.data
}

export async function getMenuListApi(id) {
  const resp = await request(`/cms/getMenuList`, 'get', {
    params: {
      id,
    },
  })
  return resp?.data
}

export async function setMenuListApi(data) {
  const resp = await request(`/cms/setMenuList`, 'post', {
    params: {
      id: data.id,
    },
    payload: {
      id: data.id,
      menu: data.menu,
    },
  })
  return resp?.data
}

export async function createMenuItemApi(data) {
  const resp = await request(`/cms/restaurants/${data?.restaurantId}/menuItem`, 'post', {
    payload: {
      item: data.item,
    },
  })
  return resp?.data
}

export async function updateMenuItemApi(data) {
  const resp = await request(`/cms/restaurants/${data?.restaurantId}/menuItem`, 'put', {
    payload: {
      item: data.item,
    },
  })
  return resp?.data
}

export async function deleteMenuItemApi(data) {
  const resp = await request(`/cms/restaurants/${data?.restaurantId}/menuItem/${data?.id}`, 'delete')
  return resp?.data
}

export async function swapMenuItems(data) {
  const resp = await request(`/cms/restaurants/${data?.restaurantId}/menuItem/swap`, 'post', {
    payload: {
      items: data.items,
      toIndex: data.toIndex,
    },
  })
  return resp?.data
}
